import React, { useEffect, useState } from 'react'
import Sidebarlayout from '../../Layouts/Sidebarlayout'
import Table from '../../Components/Table'
import '../../Assets/Css/Clients.scss'
import { useNavigate } from 'react-router-dom'
import { connect } from "react-redux"
import { getClients } from '../../Services/Clients/action'
import { Spinner } from "react-bootstrap";
import qs from "query-string";

const Clients = (props) => {

  const navigate = useNavigate();
  let path = '/clients/add';
  const [data,setData]=useState([]);
  const [params, setParams] = useState({});
  let count = props.clients?.length;

  const handleAddClick = () => {
    navigate(path);
  }

  const header = [
    { field: 'Client' },
    { field: 'Address' },
    { field: 'Country' },
    { field: 'Mobile' },
    { field: 'Managed By' },
    { field: 'Action' }
  ];

  let footer = true;

  const fetchData = () => {
    try {
      setParams(qs.parse(location.search, { ignoreQueryPrefix: true }));
      props.getClientsList(location.search);
    } catch (error) {
      console.error("Error fetching invoices:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [location.search])

  useEffect(()=>{
    props.clients && setData(props.clients.map((client) => {
      return {
        Client: {
          value: client?.name || "unknown",
          value2: client?.email,
          src: client?.src,
          type: 'client',
        },
        'Managed By': {
          value: client?.managedBy?.name || "unknown",
          value2: client?.managedBy?.email,
          src: client?.managedBy?.src,
          type: 'client',
        },
        Address: {
          value: client?.address1,
          value2: client?.address2,
          city: client?.city,
          state: client?.state,
          country: client?.country,
          postalcode: client?.postalcode,
          type: 'address'
        },
        Country: {
          value: client?.country,
          type: 'text'
        },
        Mobile: {
          value: client?.mobile,
          type: 'text'
        },
        Action: {
          value: '/clients/edit',
          value2: '/clients/view',
          type: 'action'
        },
        ClientId : {
          value : client?.id
        },
        allData : {
          ...client
        }
      }
    }));
  },[props.clients])
  
  return (
    <Sidebarlayout>
      <div className='client-main'>
        <div className="page-title">
          <h4>Clients</h4>
          <div className="edit-btn">
            <button className="custom-btn" disabled={props.loading} onClick={handleAddClick}>
              {props.loading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : "Add" }
              </button>
          </div>
        </div>
        <div className="client-list-table">
          <Table
           header={header}               
           records = {parseFloat(props.records)}
           count={count}
            defaultParams={params}
             footer={footer}
              data={data}
               loading={props.loading} />
        </div>
      </div>
    </Sidebarlayout>
  )
}

export const mapStateToProps = (state) => {
  return {
    clients: state.clientsReducer.clients.rows,
    loading : state.clientsReducer.loading,
    records : state.clientsReducer.clients.noOfRecords
  }
}

export const mapDispatchToProps = (dispatch) => {
  return {
    getClientsList: (params) => {
      dispatch(getClients(params))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Clients)
